﻿import Swiper, { Navigation, Pagination } from "swiper";

export const slideshow = () => {
  const slideshows = document.querySelectorAll("[data-js-image-slideshow]");
  
  for (const slideshow of slideshows) {
    
    setOverlaySize(slideshow);
    window.addEventListener("resize", () => setOverlaySize(slideshow));
    
    new Swiper(slideshow as HTMLElement, {
      modules: [Navigation, Pagination],
      slidesPerView: "auto",
      navigation: {
        enabled: true,
        prevEl: slideshow.querySelector(".swiper-button-prev") as HTMLElement,
        nextEl: slideshow.querySelector(".swiper-button-next") as HTMLElement
      },
      pagination: {
        el: slideshow.querySelector(".swiper-pagination") as HTMLElement,
        clickable: true,
      }
    });
  }
}

const setOverlaySize = (slideshow: Element) => {
  const picture = slideshow.querySelector("picture");
  const overlay = slideshow.querySelector("[data-js-slideshow-overlay]") as HTMLElement;
  if (picture && overlay) {
    overlay.style.width = `${picture.offsetWidth}px`;
    overlay.style.height = `${picture.offsetHeight}px`;
  }
}